import { twMerge } from 'tailwind-merge';

import { TopSpeciesCTA } from './components/TopSpeciesCTA';
import { useState } from 'react';
import { Button } from '../../../../components/Clickables/Buttons/Button';
import { Heading } from '../../../../components/Heading/Heading';
import { getEdgesFromConnection } from '../../../../helpers/graphql';
import {
  GetFishingWaterTopSpecies_fishingWater_topSpeciesSummary,
  GetFishingWaterTopSpecies_fishingWater_topSpeciesSummary_edges,
  GetFishingWaterTopSpecies_fishingWater_topSpeciesSummary_edges_node,
} from '../../../../interfaces/graphql';
import { trackEvent } from '../../../../helpers/analytics/trackEvent';
import { AppDownloadModal } from '../../../../components/AppDownloadModal/AppDownloadModal';
import { useAnalytics } from '../../../../contexts/AnalyticsContext/AnalyticsContext';
import { SUB_LINK_IDS } from '../../helpers/fishingWaterHelpers';
import { TopSpeciesLinkCard } from '../../../../components/Cards/TopSpeciesLinkCard/TopSpeciesLinkCard';

interface IProps {
  fishingWaterId: string;
  fishingWaterName: string;
  topSpeciesSummary: GetFishingWaterTopSpecies_fishingWater_topSpeciesSummary;
  className?: string;
}

export const TopSpeciesSection = ({
  fishingWaterId,
  fishingWaterName,
  topSpeciesSummary,
  className,
}: IProps) => {
  const { currentPage } = useAnalytics();
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);

  const headingText = `Top fish species at ${fishingWaterName}`;
  const speciesEdges = getEdgesFromConnection<
    GetFishingWaterTopSpecies_fishingWater_topSpeciesSummary_edges_node,
    GetFishingWaterTopSpecies_fishingWater_topSpeciesSummary_edges
  >(topSpeciesSummary);

  const handleCTAClick = () => {
    void trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        source: 'TopSpeciesSection',
        source_id: fishingWaterId,
        type: 'downloadModal',
        page: currentPage,
      },
    });
    setIsAppDownloadModalOpen(true);
  };

  return (
    <div
      id={SUB_LINK_IDS.TOP_SPECIES}
      className={twMerge(
        'scroll-mt-[--navigation-scrolltop-offset-mobile] sm:scroll-mt-[--navigation-scrolltop-offset] sm:rounded-xxl sm:bg-lake-fog md:bg-transparent md:bg-gradient-to-b md:from-lake-fog',
        className,
      )}
    >
      <Heading className="mb-4 sm:mb-8" variant="sm" as="h2">
        {headingText}
      </Heading>
      <div className="flex flex-col">
        {speciesEdges.map(({ node }, index) => {
          const image = node.image;
          const imageUrl = image.url || '';
          const imageWidth = image.width || 0;
          const imageHeight = image.height || 0;

          return (
            <TopSpeciesLinkCard
              key={`species-${node._id}`}
              speciesId={node._id}
              name={node.displayName}
              className={`w-full`}
              imageUrl={imageUrl}
              imageWidth={imageWidth}
              imageHeight={imageHeight}
              clickEventPosition={index}
              clickEventSourceId={fishingWaterId}
              clickEventSource="most-caught-species"
            />
          );
        })}
        <Button
          size="sm"
          className="mt-2 p-2 md:hidden"
          variant="textPrimary"
          onClick={handleCTAClick}
        >
          See more species
        </Button>
      </div>
      <TopSpeciesCTA onCTAClick={handleCTAClick} />
      <AppDownloadModal
        appDownloadSource="TopSpeciesSection"
        appDownloadSourceId={fishingWaterId}
        modalHeader={`Download the Fishbrain app to see all species from  ${fishingWaterName}`}
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </div>
  );
};
